import Proptypes from 'prop-types';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Text} from '../../../ui';
import css from '../styles/ChangeSignaturePopup.module.css';

const ConfirmRemovingSignaturePopupLayout = ({
  onCancelClick,
  onConfirmClick,
}) => (
  <div className={css.removeSignature}>
    <div className={css.removeSignatureTitle}>
      <Text
        fontSize={Text.FONT_SIZE.SIZE_24}
        lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
        fontWeight={Text.FONT_WEIGHT.MEDIUM}
        fontFamily={Text.FONT_FAMILY.RUBIK}
      >
        <TextLocal id={'signature.confirm-no-need-certificate'} />
      </Text>
    </div>
    <div className={css.removeSignatureDescription}>
      <Text
        fontSize={Text.FONT_SIZE.SIZE_16}
        lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
        color={Text.COLOR.GREY}
        fontWeight={Text.FONT_WEIGHT.MEDIUM}
      >
        <TextLocal id={'signature.agree-will-delete-certificate'} />
      </Text>
    </div>

    <div className={css.removeSignatureButtons}>
      <Button onClick={onCancelClick} height={Button.HEIGHT.REGULAR}>
        <TextLocal id={'general.no'} />
      </Button>
      <Button
        color={Button.COLOR.RED}
        height={Button.HEIGHT.REGULAR}
        onClick={onConfirmClick}
      >
        <Text fontWeight={Text.FONT_WEIGHT.BOLD}>
          <TextLocal id={'signature.yes-delete'} />
        </Text>
      </Button>
    </div>
  </div>
);

ConfirmRemovingSignaturePopupLayout.propTypes = {
  onCancelClick: Proptypes.func.isRequired,
  onConfirmClick: Proptypes.func.isRequired,
};

export default ConfirmRemovingSignaturePopupLayout;
